module.exports = __webpack_public_path__ + "static/media/SuranceLogoCyberAid.afb3cb90.svg";